import React from 'react';
import { Flex, Modal , Typography } from 'antd';
import catamaniaLogo from '../../images/logos/catamania.svg';

const { Text } = Typography;

const CatamaniaModal = ({setIsModalOpen, isModalOpen}) => {

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  return (
    <Flex align='center' justify='center'>
      <Modal
        title="Developer"
        centered
        open={isModalOpen}
        footer={null}
        onCancel={handleCancel}
        width={{
          xs: '90%',
          sm: '80%',
          md: '70%',
          lg: '60%',
          xl: '50%',
          xxl: '40%',
        }}
      >
        <Text>
          <br />
          During my internship at CatAmania, I worked on data extraction and analysis for an IT asset management system, focusing on optimizing data organization and automation. 
          My responsibilities included:
          <br />
          <br />
          • <strong>Extracting and analyzing data</strong> from an IT infrastructure to gain valuable insights.<br />
          • <strong>Sorting and classifying information</strong> based on relevance and usability.<br />
          • <strong>Designing a tailored data model</strong> for a new asset management system to enhance efficiency.<br />
          • <strong>Automating data processes</strong> using REST APIs for secure and efficient data access and manipulation.<br />
          <br />
          <br />
          This experience allowed me to strengthen my data processing skills, improve my ability to structure information effectively, and develop automation solutions for real-world applications.  
          Additionally, I became proficient in API-based data handling and gained insight into IT asset management best practices.
        </Text>
        <Flex justify='end'><img src={catamaniaLogo} alt='catamania-logo' width='200px' /></Flex>
      </Modal>
    </Flex>
  );
};

export default CatamaniaModal;